<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 10px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
  
   <card style="margin-bottom:80px">
 <div style="text-align:right">

    	 <p-button type="info"  @click="goToUploadDocument()" >
     			 <i slot="label" class="nc-icon nc-settings-gear-65"></i> 
               Upload Document
              </p-button>
    	
    	
    	<p-button type="info"  @click="goToManageFolders()" >
     			 <i slot="label" class="nc-icon nc-settings-gear-65"></i> 
               Manage Folders & Tags
        </p-button>
              
              
  </div>
</card>





  
  
  
  
  		 <div style="text-align:center;">
  		 
  		 <h5 style="font-weight:bold">Browse By Folders</h5>
  		 </div>
  
	    <div style="margin-top:30px;">
	       <div v-for="folder in folders">
	       	
	       	<div class="card" style="cursor:pointer;">

          		<div class="card-body" @click="viewFolder(coy.id, folder.id)">
                	<h5 style=";font-size:19px;margin-bottom:0px;">{{folder.folder_name}}</h5>
          		</div>
        	</div><!-- end card-->  
	       
	       </div>
	    </div>
	       <!-- end folders-->
        
       <div style="margin-top:50px;">
       The following documents are accessible via Document Browser
       <ul>
       		<li>All Key Documents</li>
       		<li>Documents uploaded via Document Browser</li>
       		<li>Documents attached to and generated by tasks with the following task status: "Signed" and "Completed".</li>
       </ul>
       
       </div> 
       
        <div style="text-align:right;margin-top:80px;">
    

              
  		</div>
  	
       
       <div style="margin-top:40px;">
       <h5 style="font-weight:bold;">All Documents</h5>
  		</div>
		
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="docs">
                <el-table-column label="Title" property="document_name" sortable width="500" ></el-table-column>
                <el-table-column label="Uploaded" property="created_at_str" sortable></el-table-column>
               
    			
    			  <el-table-column label="Task Status" >
    				<template slot-scope="scope">
    					<div v-if="scope.row.task">
           					 <span v-if="scope.row.task.task_status===1">Pending</span>
           					 <span v-if="scope.row.task.task_status===2">Waiting For Signature</span>
           					 <span v-if="scope.row.task.task_status===3">Signed</span>
           					 <span v-if="scope.row.task.task_status===4">Completed</span>
           					 <span v-if="scope.row.task.task_status===5">Cancaelled</span>
           				 </div>
           				  <div v-else>-</div>
          			</template>
          		 </el-table-column>
          		   <el-table-column label="Folder" property="folder_name"></el-table-column>
          		<!--  <el-table-column label="" >
    				<template slot-scope="scope">
    					<div v-if="scope.row.task">
           					 <span v-if="scope.row.task.category===1">Directors' Resolution</span>
           					 <span v-if="scope.row.task.category===2">EGM (Minutes & Resolution)</span>
           					 <span v-if="scope.row.task.category===3">AGM (Minutes & Resolution)</span>
           					 <span v-if="scope.row.task.category===13">Directors' Declaration For AGM</span>
           					 <span v-if="scope.row.task.category===5">Notice For AGM/EGM</span>
           					 
           					  <span v-if="scope.row.task.category===8">Consent To Short Notice For AGM/EGM</span>
           					  <span v-if="scope.row.task.category===6">Share Certificate</span>
           					  <span v-if="scope.row.task.category===9">Share Transfer</span>
           					  <span v-if="scope.row.task.category===11">Nominee Director Agreement</span>
           					  <span v-if="scope.row.task.category===12">Notice For AGM/EGM</span>
           					  <span v-if="scope.row.task.category===14">Certificate Of Appointment Of Representative</span>
           					 
           					  <span v-if="scope.row.task.category===15">Striking-off (Balance Sheet 0|0)'}</span>
           					  
           				 </div>
          			</template>
          		 </el-table-column>-->
          	    			
                    <el-table-column label="" width="90">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm" icon @click="viewDocument(scope.row.id)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
					</template>
               </el-table-column>
                 
            </el-table>

          </div>
        </div>
        
        
        
  
            
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {

      	this.loadMailbox();
    },
    
     
    data () {
      return {
        coy:[],
        docs:[],
        folders:[],
        new_folder_name:"",
        new_tag_name:"",
    	eid: this.$route.params.eid,
		 new_mail: {
          document_name: '',
          notes:'',
        },
        modelValidations: {
          title: {
          },
          description: {
          },
          amount: {
            required: true,
            decimal:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    loadMailbox(){
	    	let uri = this.$base_url+'/api/v1/documents/get_entity_documents/entity/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				this.coy = response.data.entity;
				this.docs = response.data.documents;
				this.folders = response.data.document_folders;
			})
	    },
	    viewMail(mid){
	    	this.$router.push( '/view-mail/'+mid);
	    
	    },
	    viewFolder(eid, dfid){
	    	this.$router.push( '/view-folder/'+dfid+"/entity/"+eid);
	    },
	    viewDocument(did){
	    	this.$router.push( '/view-document/'+did+"/1");
	    },
	    goToUploadDocument(){
	    	this.$router.push( '/upload-document/entity/'+this.$route.params.eid);
	    },
	    goToManageFolders(){
	    	this.$router.push( '/manage-folders/entity/'+this.$route.params.eid);
	    },
	    createFolder(){
	    	if( this.new_folder_name==""){
    	 			  swal({
						  title: 'Oops',
						  text: 'Please enter a name for your new folder.',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
			 		})
    	 			return false;
    	 		}
    	 		
    	  const vm = this;
       	
			swal({
				title: 'Are you sure?',
				text: 'A new folder will be created for all entities in your organization.',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes',
				buttonsStyling: false
			  }).then(function () {
				 const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/documents/create_new_folder/entity/'+vm.$route.params.eid;
			     ApiService.post(uri, {
      				'new_folder_name':vm.new_folder_name,
      		
      				}).then(response => {
					swal({
					  title: 'Done!',
					  text: 'The folder has been created successfully.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
			
						vm.$router.go()
				
					})
					//end swal
				})
		 
			
			  })//end swal-then
	    
	    },
	     createTag(){
	    	if( this.new_tag_name==""){
    	 			  swal({
						  title: 'Oops',
						  text: 'Please enter a name for your new tag.',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
			 		})
    	 			return false;
    	 		}
    	 		
    	  const vm = this;
       	
			swal({
				title: 'Are you sure?',
				text: 'A new tag will be created for all entities in your organization.',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes',
				buttonsStyling: false
			  }).then(function () {
				 const vm_ = vm;
				 let uri = vm.$base_url+'/api/v1/documents/create_new_tag/entity/'+vm.$route.params.eid;
			     ApiService.post(uri, {
      				'new_tag_name':vm.new_tag_name,
      		
      				}).then(response => {
					swal({
					  title: 'Done!',
					  text: 'The tag has been created successfully.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
			
						vm.$router.go()
				
					})
					//end swal
				})
		 
			
			  })//end swal-then
	    
	    },
	   uploadNewMail(){
    	 	   if(!this.$refs.new_file.files[0]){
    	 	   
    	 	   	return false;
    	 	   }
    	 
    	 
    	 		if( this.new_mail.document_name==""){
    	 			  swal({
						  title: 'Oops',
						  text: 'Please enter a name for this mail.',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
			 		})
    	 			return false;
    	 		}
    	 
    	 
    	 		swal.showLoading();
      			let uploaded_file = this.$refs.new_file.files[0];
      			let formData = new FormData();
  			    formData.append('file', uploaded_file);
  			    formData.append('mail_document_name', this.new_mail.document_name);
  			    formData.append('mail_notes', this.new_mail.notes);
  			    
  			    const vm = this;
  			    if(this.new_mail.document_name ==""){
  			    	this.new_mail.document_name = '-';
  			    }
  			    
  			     let uri = this.$base_url+'/api/v1/digital_mail/upload_mail/'+ this.$route.params.eid;
				 ApiService.post(uri,formData).then(response => {
						swal({
						  title: 'Uploaded.',
						  text: 'The file has been uploaded.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
								swal.close();
								vm.new_mail.document_name = '';
								vm.loadMailbox();
						})//end swal
			
				  })
      	
      	
      	}
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


